import { render } from "./market-show.vue?vue&type=template&id=e0c38200&scoped=true"
import script from "./market-show.vue?vue&type=script&lang=js"
export * from "./market-show.vue?vue&type=script&lang=js"

import "./market-show.vue?vue&type=style&index=0&id=e0c38200&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c38200"]])

export default __exports__